import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Layout from '../../../components/web/Layout';
import BlogCard from './BlogCard';

const Rules = () => {
  const [blogs, setBlogs] = useState([]);
  const [limit] = useState(6);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [total, setTotal] = useState(0);

  const fetchBlogs = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}blogs?limit=${limit}&offset=${offset}`
    );
    const data = await res.json();

    setBlogs(prev => [...prev, ...data.data]);
    setOffset(prev => prev + limit);
    setTotal(data.total);

    if (blogs.length + data.data.length >= data.total) {
      setHasMore(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <Layout>
      <div className="container max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-2xl md:text-4xl font-bold  mb-10">
          Our Latest Blogs
        </h1>

        <InfiniteScroll
          dataLength={blogs.length}
          next={fetchBlogs}
          hasMore={hasMore}
          loader={<p className="text-center py-5">Loading...</p>}
          endMessage={
            <p className="text-center py-5 text-gray-500">
              🎉 You have seen all blogs
            </p>
          }
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map(blog => (
              <BlogCard key={blog.id} blog={blog} />
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </Layout>
  );
};

export default Rules;